import styled from 'styled-components';

import Button from 'components/Button';

import { PageContainer } from 'styles/global';
import BREAKPOINTS from 'styles/breakpoints';
import COLORS from 'styles/colors';
import TYPO, { Italics, P3 } from 'styles/typography';

const Container = styled(PageContainer)`
  padding: 100px var(--gutter-side) 66px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Content = styled.div`
  max-width: 460px;
`;

const Title = styled.h1`
  ${TYPO.h4}
  margin-bottom: 20px;

  ${BREAKPOINTS.small`
    margin-bottom: 30px;
  `}
`;

const Paragraph = styled(P3)`
  margin: 0 0 25px;

  a {
    color: ${COLORS.dawn};
  }

  br {
    content: '';
    display: block;
    margin-bottom: 14px;

    ${BREAKPOINTS.small`
      margin-bottom: 16px;
    `}
  }
`;

const Feedback = ({
  title,
  subtitle,
  label,
  href,
  onClick,
  bgRoundels,
  className,
  children,
}) => {
  return (
    <Container theme="dark" bgRoundels={bgRoundels || 2} className={className}>
      <Content>
        <Title>
          {title} <br />
          <Italics>{subtitle}</Italics>
        </Title>
        {children && (
          <Paragraph mb={23} indent>
            {children}
          </Paragraph>
        )}
        {href && <Button href={href}>{label}</Button>}
        {onClick && <Button onClick={onClick}>{label}</Button>}
      </Content>
    </Container>
  );
};

export default Feedback;
